<template>
    <button class="category-menu-btn" :class="rootClasses">
        <category-menu-image :color="color" :url="image.urls.default[0]" :alt="image.alt"/>

        <!-- As a consequence of the switch to svg filters in the image, I had to disable the picture element: -->
        <!--<picture-element class="category-menu-btn&#45;&#45;image" v-bind="image"/>-->

        <span class="category-menu-btn--content">
            <h2 class="u-reset category-menu-btn--title">
                {{ title }}
            </h2>
            <snake-pattern class="u-reset category-menu-btn--snake-pattern"/>
            <span class="category-menu-btn--tile-icon">
                <ui-icon symbol="category-tiles" size="medium"/>
            </span>
        </span>
    </button>
</template>

<script>
    import CategoryMenuImage from 'framework/components/category-menu-image/category-menu-image';
    import SnakePattern from 'framework/global-components/snake-pattern/snake-pattern';
    import UiIcon from '@dreipol/vue-ui/src/components/icon/icon.vue';
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';
    import { RESOURCE_TYPES } from 'util/project/helpers';

    export default {
        components: {
            CategoryMenuImage,
            SnakePattern,
            UiIcon,
        },
        mixins: [
            bemMixin('category-menu-btn'),
        ],
        props: {
            color: {
                type: String,
                default: null,
            },
            title: {
                type: String,
                required: true,
            },
            type: {
                type: String,
                default: null,
            },
            /** @type {IImageSet} */
            image: {
                type: Object,
                required: true,
            },
        },
        computed: {
            rootClasses() {
                return [
                    ...this.bemFacets,
                    this.bemAdd(this.type ? `type-${ this.type === RESOURCE_TYPES.ROOT ? 'root' : 'main' }` : null),
                    this.bemAdd(this.color ? `main-category-facet-${ this.color }` : null),
                ];
            },
        },
    };
</script>
